module.exports = __webpack_public_path__ + "img/DZ.34945cab.svg";